import { EntityTypes } from '../../../typings';

export const DEFAULT_MAX_CUSTOM_FIELD_FILTER_CONDITIONS = 5;

export type CustomFieldDataType = 'text' | 'number' | 'date' | 'boolean' | 'single_select' | 'multi_select';

export type CustomFieldOperatorType =
  | 'EQUALS'
  | 'NOT_EQUALS'
  | 'CONTAINS'
  | 'NOT_CONTAINS'
  | 'STARTS_WITH'
  | 'ENDS_WITH'
  | 'LESS_THAN'
  | 'LESS_THAN_EQUAL_TO'
  | 'GREATER_THAN'
  | 'GREATER_THAN_EQUAL_TO'
  | 'BETWEEN'
  | 'NOT_BETWEEN'
  | 'ON_DATE'
  | 'NOT_ON_DATE'
  | 'BEFORE_DATE'
  | 'AFTER_DATE'
  | 'IN_THE_LAST'
  | 'NOT_IN_THE_LAST'
  | 'ANY_OF'
  | 'ALL_OF'
  | 'NONE_OF'
  | 'IS_SET'
  | 'IS_NOT_SET';

export type CustomFieldValueShape = 'VALUE' | 'BETWEEN' | 'NO_VALUE' | 'DATE_PERIOD';

export type DatePeriodSuffix = 'seconds' | 'minutes' | 'hours' | 'days' | 'weeks' | 'months' | 'years';

export interface CustomFieldFieldMetadata {
  id: string;
  name: string;
  dataType: CustomFieldDataType;
  entityType?: EntityTypes;
  filterable: boolean;
}

export interface CustomFieldOperatorMetadata {
  id: number;
  type: CustomFieldOperatorType;
  name: string;
  valueType: CustomFieldValueShape;
  suffix?: DatePeriodSuffix[];
}

export interface CustomFieldFilterMetadata {
  fields: CustomFieldFieldMetadata[];
  dataTypeOperator: Partial<Record<CustomFieldDataType, CustomFieldOperatorMetadata[]>>;
  maxCustomFieldFilterConditions?: number;
}

export type CustomFieldConditionValue =
  | { type: 'VALUE'; value: string | number | boolean | string[] }
  | { type: 'BETWEEN'; start: string | number; end: string | number }
  | { type: 'DATE_PERIOD'; value: number; suffix: DatePeriodSuffix }
  | { type: 'NO_VALUE' };

export interface CustomFieldCondition {
  id: string;
  type: CustomFieldDataType;
  operator: CustomFieldOperatorType;
  value: CustomFieldConditionValue;
}

export interface SelectValueLabel {
  value: string;
  label: string;
}

export interface FilterFieldValueResponse {
  values: SelectValueLabel[];
  hasMore: boolean;
  nextSearchAfter: string | null;
}

export interface FilterFieldValueRequestArgs {
  fieldId: string;
  search?: string;
  searchAfter?: string;
}
